<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import Timeline from "primevue/timeline";
import { ProfileAdministrationAPI } from "../../api";
import { Participant, ParticipantActivity } from "../../types/PersologOnlineTypes";
import { formatDate, isMobileView } from "../../utils/GeneralUtils";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
    participant: {
        type: Object as () => Participant,
        required: true,
    },
});

const activity = ref<ParticipantActivity[]>([]);

async function fetchActivity() {
    const events: ParticipantActivity[] = await ProfileAdministrationAPI.getParticipantActivity(props.participant.id!);

    activity.value = events
        .map((item) => ({
            id: item.id!,
            type: item.type,
            date: item.date,
            profileLanguage: item.profileLanguage,
        }))
        .sort((a, b) => +new Date(a.date) - +new Date(b.date));
}

watch(() => props.participant.status, fetchActivity);

onMounted(fetchActivity);
</script>

<template>
    <div class="input-container">
        <label :for="`participant-activity-timeline-${participant.id}`" class="label">{{ t("project-details.participants.activity.show") }}</label>
        <Timeline :id="`participant-activity-timeline-${participant.id}`" :value="activity" :style="{ marginLeft: isMobileView(991) ? '0' : '-50%' }">
            <template #opposite="slotProps">
                <small class="p-text-secondary">{{ formatDate(slotProps.item.date, t("formats.datetime")) }}</small>
            </template>
            <template #content="slotProps">
                {{
                    t(`project-details.participants.activity.${slotProps.item.type.toLowerCase()}`, {
                        language: slotProps.item.profileLanguage?.toUpperCase() ?? "",
                    })
                }}
            </template>
        </Timeline>
    </div>
</template>

<style scoped>
.input-container {
    display: flex !important;
    flex-direction: column !important;
    align-items: left;
}

.label {
    font-size: 12px;
    color: #7e868d;
}
</style>
